import { useAuth } from "../../contexts/user.context";

const Header = () => {
  const { isLoggedIn, logoutUser } = useAuth();

  const handleLogout = async () => {
    logoutUser();
    window.location.reload();
  };

  return (
    <div className="flex justify-between box-border w-full h-8 my-4">
      <a href="/">
        <img
          draggable="false"
          src="logo.png"
          alt="logo cashtracker"
          width={"175px"}
        ></img>
      </a>
      {isLoggedIn ? (
        <button
          onClick={handleLogout}
          className="font-inter rounded-full text-xs px-6 items-center bg-main-black text-main-white"
        >
          LOG OUT
        </button>
      ) : null}
    </div>
  );
};

export default Header;
